import { render } from "./ContactBody.vue?vue&type=template&id=5f37e0be"
import script from "./ContactBody.vue?vue&type=script&lang=js"
export * from "./ContactBody.vue?vue&type=script&lang=js"
script.render = render

export default script